import React from 'react'
import PropTypes from 'prop-types'
import { constants, mixpanel } from 'common/helpers'

import Button from 'components/_new/Button/Button'
import Box from 'components/_new/layout/Box/Box'

import messages from './messages'


const AddToQueueButton = ({ gender, link }) => (
  <Box mt="36">
    <Button
      dataTestId={constants.testIds.thankYouPage.addToQueueButton}
      color="brand"
      size="md"
      weight="normal"
      title={{
        ...messages.startAddingToQueue,
        values: { gender },
      }}
      to={link}
      onClick={() => mixpanel.track(constants.analyticsEvents.thankYouAddToQueue)}
      uppercase
    />
  </Box>
)

AddToQueueButton.propTypes = {
  gender: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}


export default AddToQueueButton
